import { useIsFetching, useIsMutating } from "react-query";
import { LinearProgress } from "@mui/material";

const FetchingIndicator = () => {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const displayLoader = isFetching > 0 || isMutating > 0;

  if (!displayLoader) return null;

  return <LinearProgress sx={{ position: "fixed", top: 0, width: "100%" }} />;
};
export default FetchingIndicator;
